import React from 'react'
import { pick } from 'lodash-es'
import { useListStore } from '@ow/ditto-core'

const Operate = function (props) {
  const { OperateComponent, FixedOperateComponent, showFixedOperation } =
    useListStore((state) =>
      pick(state, [
        'OperateComponent',
        'FixedOperateComponent',
        'showFixedOperation',
      ])
    )

  return showFixedOperation ? (
    <FixedOperateComponent {...props} />
  ) : (
    <OperateComponent {...props} />
  )
}

export default Operate
